import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static classes = ["active"]
  static targets = ["btn", "tab"]
  static values = {
    defaultTab: String,
    categories: Array,
    storageKey: { type: String, default: "tabs:last" }
  }

  connect() {
    this.tabTargets.forEach(x => x.hidden = true)

    const lastId = localStorage.getItem(this.storageKeyValue)
    const targetId = this.findExistingId(lastId) || this.findExistingId(this.defaultTabValue)

    this.activateById(targetId)
  }

  select(event) {
    const targetId = event.currentTarget.id

    this.tabTargets.forEach(x => x.hidden = true)
    this.btnTargets.forEach(x => x.classList.remove(...this.activeClasses))
    this.activateById(targetId)

    localStorage.setItem(this.storageKeyValue, targetId)

    const selectedTab = this.tabTargets.find(el => el.id === targetId)
    const categoryId = selectedTab?.dataset?.itemEditorCategoryId

    if (categoryId) console.log(`Tab changed to: ${targetId}, Category ID: ${categoryId}`)
  }

  activateById(id) {
    const tabEl = this.tabTargets.find(el => el.id === id)
    const btnEl = this.btnTargets.find(el => el.id === id)

    if (!tabEl || !btnEl) return

    tabEl.hidden = false
    btnEl.classList.add(...this.activeClasses)
  }

  findExistingId(id) {
    if (!id) return null
    return (this.tabTargets.some(el => el.id === id) ? id : null)
  }
}
